export function isZkSyncChain(chain) {
    return (chain.id === 324 ||
        chain.id === 300 ||
        chain.id === 302 ||
        chain.id === 11124);
}
//# sourceMappingURL=isZkSyncChain.js.map